import { useRouter } from "next/router";

export interface SearchParamsInterface {
  setParams?: Array<{ name: string; value?: string | undefined }>;
  deleteParams?: Array<{ name: string; value?: string | undefined }>;
}

const useSearchParamsUpdate = () => {
  const { pathname, query, push } = useRouter();

  const handleSearchParamsUpdate = ({
    setParams,
    deleteParams,
  }: SearchParamsInterface) => {
    const searchParams = new URLSearchParams(query as Record<string, string>);

    setParams?.forEach((param) => {
      searchParams.set(param.name, param.value || "");
    });

    deleteParams?.forEach((param) => {
      searchParams.delete(param.name);
    });

    void push(`${pathname}?${searchParams.toString()}`, undefined, {
      shallow: true,
    });
  };

  return handleSearchParamsUpdate;
};

export default useSearchParamsUpdate;
